import React, { useEffect, useRef, useState } from 'react';
import './Quotations.scss';
import { Button, DataGrid, LoadPanel, Menu, Popup } from 'devextreme-react';
import { Column } from 'devextreme-react/cjs/data-grid';
import NewQuotation from '../NewQuotation/NewQuotation';
import axios from 'axios';
import GlobalParams from '../../helpers/GlobalParams';
import { Item } from 'devextreme-react/cjs/context-menu';
import ApiPostHelper from '../../helpers/ApiPostHelper';
import notify from 'devextreme/ui/notify';

const Quotations = () => {

  const [quotationData, setQuotationData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [popupQuoteVisible, setPopupQuotationVisible] = useState(false);
  const hideQuotePopup = () => {
    setPopupQuotationVisible(false);
    fetchQuotation();
  };

  const fetchQuotation = async () => {
    try {

      let client_url = GlobalParams.ApiUrlPrefix + 'view-quotation?broker_id=' + GlobalParams.IntermediaryId;

      const result = await axios.get(
        client_url,
        {
          headers: {
            'Authorization': 'Bearer ' + GlobalParams.bearerToken // Include bearer token in the Authorization header
          }
        }
      );
      setQuotationData(result.data.data);
      setIsLoading(false);
    } catch (error) {
      // Handle error, e.g., show an error message
      console.log(error);
      setIsLoading(false);
      //notify(error.response.data.message, 'error', 5000);
    }
  };

  //////report popup//////////
  const containerRef = useRef(null);
  const renderPdfViewer = (base64PDF) => {
    const container = containerRef.current;

    if (container) {
      const viewerObject = document.createElement('object');
      viewerObject.type = 'application/pdf';
      viewerObject.style.width = '100%';
      viewerObject.style.height = '800px';
      viewerObject.data = 'data:application/pdf;base64,' + base64PDF;

      container.appendChild(viewerObject);
    }
  };
  const fetchRpt = async (url) => {
    try {

      const result = await ApiPostHelper.postData(
        GlobalParams.LoginApiUrlPrefix + 'getReportsLaravel',
        GlobalParams.bearerToken,
        JSON.stringify({
          url_path: url,
        })
      );

      console.log("I am here brother");
      console.log(result.success);
      if (!result.success) {
        setIsLoading(false);
        setPopupReportVisible(false);
        notify("Report Error", 'error', 5000);
      }

      console.log(result.data);
      setPopupReportVisible(true);
      // Delay setting isLoading to false until after renderPdfViewer completes
      renderPdfViewer(result.data);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
      notify("Error Fetching the report", 'error', 5000);
    } finally {
      // Set isLoading to false after renderPdfViewer completes
      setIsLoading(false);
    }
  };
  const [popupReportVisible, setPopupReportVisible] = React.useState(false);
  const [report_name, setreport_name] = React.useState('');
  const hideReportButtonClick = () => {
    if (containerRef.current) {
      containerRef.current.innerHTML = '';
    }
    setPopupReportVisible(false);
    fetchQuotation();
  };
  //////end of report popup///


  useEffect(() => {
    fetchQuotation();
  }, []);

  const onMenuItemClick = (cellInfo, item) => {

    if (item === 'View Quote') {
      //cellInfo.data.CommissionReference
      setreport_name('Quotation Rpt');
      //setPopupReportVisible(true);
      setIsLoading(true);

      //cellInfo.data.MemberId

      let url =
        GlobalParams.RptUrlPrefix +
        'reportType=020&referenceNumber=' + cellInfo.data.Id + '&email=' + GlobalParams.UserEmail;

      fetchRpt(url);
    }

  };
  const menuItems = [
    { text: 'View Quote', icon: 'edit' }
  ];
  const actionColumnTemplate = (cellInfo) => {
    return (
      <div>
        <Menu
          onItemClick={(e) => onMenuItemClick(cellInfo, e.itemData.text)}
        >
          <Item
            text=" "
            items={menuItems}
          >
          </Item>
        </Menu>
      </div>
    );
  };

  return (
    <div>
      {isLoading && <LoadPanel visible={true} />}
      <div>
        <Popup style={{
          padding: 20,
        }}
          visible={popupReportVisible}
          title={report_name}
          dragEnabled={true}
          showCloseButton={true}
          hideOnOutsideClick={false}
          onHiding={hideReportButtonClick}
        >
          <LoadPanel visible={isLoading} />
          <div ref={containerRef} id="pdf-container"></div>
        </Popup>
      </div>
      <br />
      <div>
        <Popup
          visible={popupQuoteVisible}
          onHiding={hideQuotePopup}
          title="REQUEST A NEW QUOTATION"

        >
          <NewQuotation onClosePopup={hideQuotePopup} />
        </Popup>
      </div>
      <br />
      <div>
        <Button
          type='danger'
          text="Request a New Quote"
          icon='edit'
          onClick={() => {
            setPopupQuotationVisible(true);
          }}
        />
      </div>
      <br />
      <div>
        <DataGrid
          dataSource={quotationData}
          wordWrapEnabled={true}
          allowColumnReordering={true}
          searchPanel={
            {
              visible: false,
              width: 250
            }
          }
          headerFilter={{ visible: true }}
          filterRow={
            {
              visible: true,
              applyFilter: 'auto',
            }
          }
        >
          <Column width={50} caption="" cellRender={actionColumnTemplate} />
          <Column dataField="Id" visible={false}></Column>
          <Column dataField="ProductName" caption='Product'
            lookup={{
              dataSource: GlobalParams.ProductClasses,
              displayExpr: "Description",
              valueExpr: "class_code"
            }}></Column>
          <Column dataField="Quotation_name"></Column>
          <Column dataField="QuotationNumber"></Column>
          <Column dataField="Status" lookup={{
              dataSource: GlobalParams.ProductClasses,
              displayExpr: "Description",
              valueExpr: "class_code"
            }}
          ></Column>
          <Column dataField="total_members"></Column>
          <Column dataField="total_salary" cellRender={(cellInfo) => {
            const formattedAmount = parseFloat(cellInfo.data.total_salary).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
            return (
              <span>{formattedAmount}</span>
            );
          }} />
          <Column dataField="sum_assured" cellRender={(cellInfo) => {
            const formattedAmount = parseFloat(cellInfo.data.sum_assured).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
            return (
              <span>{formattedAmount}</span>
            );
          }} />
          <Column dataField="lc_premium" caption='Death Cover Premium' cellRender={(cellInfo) => {
            const formattedAmount = parseFloat(cellInfo.data.lc_premium).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
            return (
              <span>{formattedAmount}</span>
            );
          }} />
          <Column dataField="riderPremium" cellRender={(cellInfo) => {
            const formattedAmount = parseFloat(cellInfo.data.riderPremium).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
            return (
              <span>{formattedAmount}</span>
            );
          }} />
          <Column dataField="total_prem" cellRender={(cellInfo) => {
            const formattedAmount = parseFloat(cellInfo.data.total_prem).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
            return (
              <span>{formattedAmount}</span>
            );
          }} />
        </DataGrid>
      </div>
    </div>
  );

}
export default Quotations;